import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useContext, useMemo } from "react";
import { customTheme } from "../../../../../../config/theme/MuiTheme";
import { setSnackbar } from "../../../../../../util/state/globalAction";
import { GlobalContext } from "../../../../../../util/state/GlobalContextProvider";
import { snackbarTypes } from "../../../../../../util/state/globalVariables";
import { ContextOperation } from "../../../../context/OperationContext";
import { EquipmentKitService } from "../EquipmentKitService";
import EquipmentKitTypes from "../Types";
import { useEquipmentKitTabTranslation } from "../Utils";

export type EquipmentKitDeleteTypes = "kit" | "equipment";

interface Props {
  tenant:string;
  isOpen: boolean;
  onClose: () => void;
  deleteType: EquipmentKitDeleteTypes;
  equipmentKit?: EquipmentKitTypes.IEquipmentKit;
  equipment?: EquipmentKitTypes.IEquipmentsValid;
  onUpdateDatasource?: () => void;
}

const DeleteConfirmation = (props: Props) => {
  const { dispatchGlobalData } = useContext(GlobalContext);
  

  const { t } = useEquipmentKitTabTranslation();

  const onDeleteEquipmentKit = () => {
    if (props.equipmentKit) {
      EquipmentKitService.delete.kit(props.tenant,props.equipmentKit.id).then(
        () => {
          props.onClose();

          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("deleteConfirmation.succesfull"),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
              },
            },
          });

          props.onUpdateDatasource && props.onUpdateDatasource();
        },
        () => {
          props.onClose();
          
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("deleteConfirmation.errorKit"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        }
      )
    }
  }

  const onDeleteEquipment = () => {
    if (props.equipment && props.equipmentKit) {
      EquipmentKitService.delete.equipment(props.tenant,props.equipmentKit.id, props.equipment.id).then(
        () => {
          props.onClose();

          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("deleteConfirmation.removedEquipment"),
                type: snackbarTypes.success,
                show: true,
                autoClose: true,
              },
            },
          });

          props.onUpdateDatasource && props.onUpdateDatasource();
        },
        () => {
          props.onClose();
          
          dispatchGlobalData({
            type: setSnackbar,
            payload: {
              snackbar: {
                message: t("deleteConfirmation.errorRemove"),
                type: snackbarTypes.error,
                show: true,
                autoClose: true,
              },
            },
          });
        }
      )
    }
  }

  const onDelete = () => {
    if (props.deleteType === "kit") {
      onDeleteEquipmentKit();
    }

    if (props.deleteType === "equipment") {
      onDeleteEquipment();
    }
  }

  const textMessage = useMemo(() => {
    if (props.deleteType === "equipment") {
      return `"${props.equipment?.code} - ${props.equipment?.descr}"`;
    }

    if (props.deleteType === "kit") {
      return `"${props.equipmentKit?.code} - ${props.equipmentKit?.descr}"`;
    }
  }, [props.equipment, props.equipmentKit, props.deleteType]);
  return (
    <Mui.Dialog open={props.isOpen} onClose={props.onClose}>
      <Mui.DialogTitle>
        <Mui.Grid container columnSpacing={1}>
          <Mui.Grid item xs="auto" color={customTheme.palette.accent.main}>
            <MuiIcons.Info color="inherit" />
          </Mui.Grid>

          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h5">
              {t("deleteConfirmation.title")}
            </Mui.Typography>
          </Mui.Grid>

          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={props.onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>

      <Mui.DialogContent>
        <Mui.Typography variant="bodySmall" color="#18305B" style={{ whiteSpace: "pre-line" }}>
          {t("deleteConfirmation.description").replace("#textElement", textMessage || "")}
        </Mui.Typography>
      </Mui.DialogContent>

      <Mui.DialogActions>
        <Mui.Button variant="outlined" onClick={props.onClose}>
          {t("deleteConfirmation.actions.cancel")}
        </Mui.Button>

        <Mui.Button variant="contained" onClick={onDelete}>
          {props.deleteType === "equipment"
            ? t("deleteConfirmation.actions.deleteEquipment")
            : t("deleteConfirmation.actions.deleteKit")
          }
        </Mui.Button>
      </Mui.DialogActions>
    </Mui.Dialog>
  )
}

export default DeleteConfirmation;